import { configureStore,createStore} from '@reduxjs/toolkit'
import ReducerbedInfos from './stores/reducer_bedInfos';
import ReducerResidentsArray from './stores/reducer_residentsArray';
import ReducerThunkResidents from './stores/reducer_thunk_residents';
import ReducerUsersArray from './stores/reducer_usersArray';
import ReducerPadsArray from './stores/reducer_padsArray';
import ReducerBedsArray from './stores/reducer_beds'
import reducer_HistoryData from './stores/reducer_HistoryData';
import reducer_alerts from './stores/reducer_alerts';
import reducer_add from './stores/reducer_add';
import reducer_HistoryPage from './stores/reducer_HistoryPage';
import reducer_bedRealtime from './stores/reducer_bedRealtime';
/* Redux/fetchAPI */
import ReducerThunkbedStatus2ui from './stores/reducer_thunk_bedStatus2ui';
import reducer_LayoutPage from './stores/reducer_LayoutPage';
import reducer_bedsteadsArray from './stores/reducer_bedsteadsArray';
import reducer_Device from './stores/reducer_Device';
import reducer_loginStatus from './stores/reducer_loginStatus';


export const store = configureStore({
  reducer: {
    store_alerts:reducer_alerts,
    store_historyData:reducer_HistoryData,
    store_beds:ReducerBedsArray,
    store_mac_alert_setting:ReducerPadsArray,
    store_users:ReducerUsersArray,
    store_residents:ReducerResidentsArray,
    store_bed_infos: ReducerbedInfos,
    store_bedsteads: reducer_bedsteadsArray,
    store_add_response:reducer_add,
    store_bedRealtime: reducer_bedRealtime,
    /* Redux/fetchAPI */
    store_thunk_residents: ReducerThunkResidents,
    store_thunk_bedStatus2ui: ReducerThunkbedStatus2ui,
    // store_add_response:reducer_add,
    store_hisPage:reducer_HistoryPage,
    store_layout: reducer_LayoutPage,
    store_device: reducer_Device,
    store_loginStatus: reducer_loginStatus,

  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const loginStore = createStore(reducer_loginStatus)
